import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = ["form"];
  static values = {
    url: String,
  };

  async submitForm(event) {
    event.preventDefault();
    await this.submitData();
  }

  async handleButtonClick(event) {
    event.preventDefault();
    await this.submitData();
  }

  async submitData() {
    const combinedParams = this.collectAllParams();
    await this.performRequest(combinedParams.toString());
  }

  async verwijder_filter(event) {
    event.preventDefault();
    const filteredParams = this.filterZoekParams(
      this.collectAllParams(),
      (key, value) => {
        return (
          key !== `filter[${event.params.verwijderFilterFilter}][]` ||
          value !== event.params.verwijderFilterOptie
        );
      },
    );
    await this.performRequest(filteredParams.toString());
  }

  async wis_alle_filters(event) {
    event.preventDefault();
    const filteredParams = this.filterZoekParams(
      this.collectAllParams(),
      (key) => !key.startsWith("filter"),
    );
    await this.performRequest(filteredParams.toString());
  }

  filterZoekParams(params, filterFn) {
    const filtered = new URLSearchParams();
    for (const [key, value] of params.entries()) {
      if (filterFn(key, value)) {
        filtered.append(key, value);
      }
    }
    return filtered;
  }

  collectAllParams() {
    const params = new URLSearchParams();
    this.collectFormParams(params);
    this.collectStandaloneCheckboxes(params);
    this.collectSortParam(params);
    return params;
  }

  collectFormParams(params) {
    this.formTargets.forEach((form) => {
      const formData = new FormData(form);
      for (const [key, value] of formData.entries()) {
        if (value && value !== "") {
          params.append(key, value);
        }
      }
    });
  }

  collectStandaloneCheckboxes(params) {
    const mainCheckboxes = document.querySelectorAll(
      'input[type="checkbox"]:not(form input):not(#filters *)',
    );
    const offcanvasCheckboxes = document.querySelectorAll(
      '#filters input[type="checkbox"]:not(form input)',
    );
    const all = [...mainCheckboxes, ...offcanvasCheckboxes];
    all.forEach((checkbox) => {
      if (checkbox.checked) {
        params.append(checkbox.name, checkbox.value);
      }
    });
  }

  collectSortParam(params) {
    const sorteerSelect = document.querySelector("#sorteer");
    params.append("sorteer", sorteerSelect.value);
  }

  async performRequest(queryString) {
    try {
      const url = queryString
        ? `${this.urlValue}?${queryString}`
        : this.urlValue;

      this.updateBrowserUrl(queryString);

      const response = await get(url, {
        responseKind: "turbo-stream",
      });
    } catch (error) {
      console.error("Request error:", error);
    }
  }

  updateBrowserUrl(queryString) {
    const currentUrl = new URL(window.location);
    const basePath = currentUrl.pathname;

    let newUrl = basePath;
    if (queryString && queryString.trim() !== "") {
      newUrl += `?${queryString}`;
    }
    // Only update if the URL actually changed to avoid unnecessary history entries
    if (newUrl !== window.location.pathname + window.location.search) {
      history.replaceState({}, "", newUrl);
    }
  }

  async laadMeer(event) {
    try {
      const params = this.collectAllParams();
      let filterParams = params.toString();
      if (!!filterParams) {
        filterParams = `&${filterParams}`;
      }
      const url = `${event.params.meerUrl}?q=${event.params.zoekterm}${filterParams}&pagina_nr=${event.params.paginanummer}`;
      const response = await get(url, {
        responseKind: "turbo-stream",
      });
    } catch (error) {
      console.error("Request error:", error);
    }
  }
}
